import { z } from 'zod';
import { stageSchema } from './common.ts';

export const healthSchema = z.object({
  ok: z.boolean(),
  stage: stageSchema,
  version: z.string(),
  time: z.iso.datetime(),
  db: z.enum(['ok', 'waking', 'error', 'skipped']),
});
export type Health = z.infer<typeof healthSchema>;

/** Browser errors posted to /api/client-errors (replaces the prototype's Debug log tab). */
export const clientErrorReportSchema = z.object({
  message: z.string().max(2_000),
  stack: z.string().max(10_000).optional(),
  url: z.string().max(2_000),
  build: z.string().max(100),
  at: z.iso.datetime(),
});
export type ClientErrorReport = z.infer<typeof clientErrorReportSchema>;
